import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { Box } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import { usePqrTimesDetail } from './hook';
import { PqrTimesData } from './data';
import { PqrTimesDate } from './dateTimes';
import { PqrTimesRegisterHistory } from './registerHistory';
import { PqrTimesParamsHistorical } from '../historical';

import { LayoutModule } from '../../../../layout/modules';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';
import {
    PQR_TIMES_NEW,
    PQR_TIMES,
    PQR_TIMES_EDIT,
} from '../../../../../routes/paths';

export const PqrTimesDetail = () => {
    const { pqrTimes, pqrTimesHistorical, showHistorical, setShowHistorical } =
        usePqrTimesDetail();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { status } = logUser || {};

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    return (
        <>
            <LayoutModule
                title="Detalle Estado PQR"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={pqrTimes?.id || ''}
                        buttonCreate={{
                            show: !isOnlyViewProfile(status),
                            route: PQR_TIMES_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: PQR_TIMES,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(status),
                            route: PQR_TIMES_EDIT,
                        }}
                        buttonLog={{
                            show: Boolean(pqrTimes?.id),
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <PqrTimesParamsHistorical
                            historical={pqrTimesHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title=""
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <PqrTimesData data={pqrTimes} />
                    <PqrTimesDate data={pqrTimes} />
                </LayoutModule>
            </LayoutModule>
            <PqrTimesRegisterHistory pqrTimes={pqrTimes} />
        </>
    );
};
